// extracted by mini-css-extract-plugin
export default {"detailsStepContainer":"JA_CQ7"};